import { render, staticRenderFns } from "./MemberCenterUnbind.vue?vue&type=template&id=c960250a&scoped=true&"
import script from "./MemberCenterUnbind.vue?vue&type=script&lang=js&"
export * from "./MemberCenterUnbind.vue?vue&type=script&lang=js&"
import style0 from "./MemberCenterUnbind.vue?vue&type=style&index=0&id=c960250a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c960250a",
  null
  
)

export default component.exports